import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Asegúrate de importar Link
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Opcional, para un ícono
import { faRocket, faPlayCircle } from '@fortawesome/free-solid-svg-icons'; // Íconos de ejemplo

const CallToAction = () => {
    const appName = "MyFit Menu AI"; // O el nombre de tu app

    return (
        <section className="cta py-5 text-white text-center">
            <Container>
                {/* Puedes añadir un ícono grande aquí si quieres */}
                {/* <FontAwesomeIcon icon={faRocket} size="3x" className="mb-3 text-white-75" /> */}

                <h2 className="display-5 fw-bolder mb-3">
                    Ready to Transform Your Health?
                </h2>
                <p className="lead fs-5 mb-4 mx-auto" style={{ maxWidth: '700px' }}>
                    Unlock personalized meal plans, AI-powered food insights, and fitness routines tailored just for you.
                    Start your journey with {appName} today—it's free to get started!
                </p>

                <Button
                    as={Link}
                    to="/register" // Enlaza a la página de registro
                    variant="success" // Variante clara sobre fondo oscuro (Bootstrap lo maneja bien)
                    // O podrías usar "warning" o un color de acento.
                    size="lg"
                    className="px-5 py-3 fw-bold rounded-pill shadow-lg cta-main-button" // Clases para estilo
                >
                    <FontAwesomeIcon icon={faPlayCircle} className="me-2" /> {/* Ícono opcional */}
                    Get Started Free
                </Button>
            </Container>
            {/* Puedes añadir estilos específicos para .cta-main-button en tu CSS global o aquí con <style jsx> */}
            <style jsx global>{`
                .cta-main-button {
                    transition: transform 0.2s ease-out, box-shadow 0.2s ease-out !important;
                    /* Si usas variant="light", el texto es oscuro. Si quieres texto blanco,
                       podrías necesitar una clase personalizada y !important si es necesario,
                       o elegir una variante como "outline-light" y estilizar su hover */
                }
                .cta-main-button:hover {
                    transform: translateY(-3px) scale(1.03);
                    box-shadow: 0 0.75rem 1.5rem rgba(0,0,0,0.2) !important;
                }
                .bg-primary.text-white .lead { /* Hacer el lead text un poco más brillante */
                    color: rgba(255, 255, 255, 0.85) !important;
                }
            `}</style>
        </section>
    );
};

export default CallToAction;